<template>
  <div>
    <div v-if="hasHash" class="b-1">
      <img :src="logo_url" alt="logo">
    </div>

    <v-card class="p-4" :loading="loading">
      <v-card-title class="mb-4">
        <span class="title-modal">
          FAQ - Perguntas Frequentes
        </span>
        <i v-if="isPublic" class="fas fa-window-close ml-auto icon-close-modal"
           @click.prevent="closeModal"></i>
      </v-card-title>
      <v-expansion-panels v-show="!loading && articles.length > 0" v-model="expandedPanel">
        <v-expansion-panel
            v-for="(article) in articles"
            :key="article.id"
            :ref="`panel-${article.slug}`"
        >
          <v-expansion-panel-header class="title font-weight-bold header-color">{{
              article.title
            }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="ql-editor" v-html="article.content"></div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card-text v-show="!loading && articles.length <= 0">
        Sem artigos para mostrar
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Faq",
  props: {
    isPublic: {
      type: Boolean,
      default: false,
    },
    slug: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      loading: false,
      articles: [],
      expandedPanel: null,
      error: null,
      hasHash: false,
    }
  },
  mounted() {
    this.getData();
    this.checkHashExists();
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
        this.checkHashExists();
        this.checkSlugFromHash();
      }
    }
  },
  computed: {
    logo_url() {
      return require('@/assets/imgs/logos/' + process.env.VUE_APP_LOGO_NAME);
    },
  },
  methods: {
    closeModal: function () {
      this.$emit("onClose");
    },
    getData: async function () {
      try {
        this.loading = true;

        const {data: {data}} = await axios.get('/api/public/faq');
        this.articles = data;

        this.$nextTick(() => {
          this.checkSlugFromHash();
        });
      } catch (e) {
        this.error = e;
      } finally {
        this.loading = false;
      }
    },
    checkHashExists: function () {
      this.hasHash = !!this.$route.hash;
    },
    checkSlugFromHash: function () {
      let targetSlug = this.slug;

      if (!targetSlug && this.$route.hash) {
        targetSlug = this.$route.hash.substring(1);
        this.hasHash = true;
      }

      if (!targetSlug || this.articles.length === 0) {
        return
      }

      const articleIndex = this.articles.findIndex(article => article.slug === targetSlug);

      if (articleIndex === -1) {
        return
      }
      this.expandedPanel = articleIndex;

      this.$nextTick(() => {
        this.scrollToPanel(targetSlug);
      });
    },
    scrollToPanel: function (slug) {
      setTimeout(() => {
        const panelRef = this.$refs[`panel-${slug}`];

        if (panelRef && panelRef.length === 0) {
          return;
        }

        const element = panelRef[0].$el;

        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 300);
    }
  },
}
</script>

<style scoped>
.header-color {
  color: #595959
}

.b-1 {
  padding: 15px;
  text-align: center;
  border-bottom: 1px solid #e0e0e0;
  background-color: #ffffff;
}

.b-1 img {
  max-height: 60px;
  max-width: 200px;
}
</style>